import { useState } from 'react';
import { observer } from 'mobx-react';
import { PodcastModel } from 'app/stores/podcast.store';
import { PodcastPlayer } from 'app/components/shared/PodcastPlayer';
import Config from 'Config';

// Hardcoded podcasts for the special series
const hardcodedPodcasts: PodcastModel[] = [
	{
		id: 'episode-1',
		title: 'Vorwort zum Format und Allgemeines zum Vertragsmodell',
		authors: 'VM-VV, Recht',
		audioFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-1.mp3`,
		videoFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-1.mp4`,
	},
	{
		id: 'episode-2',
		title: 'Vergütungsmodell Pro3',
		authors: 'VM-VV, Recht',
		audioFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-2.mp3`,
		videoFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-2.mp4`,
	},
	{
		id: 'episode-3',
		title: 'Altersversorgung',
		authors: 'VM-VV, Recht',
		audioFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-3.mp3`,
		videoFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-3.mp4`,
	},
	{
		id: 'episode-4',
		title: 'Gründung und Einnahmekalkulation',
		authors: 'VM-VV, Recht',
		audioFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-4.mp3`,
		videoFilePath: `${Config.API_BASE_URL}/uploads/podcasts/agenturgruendung-4.mp4`,
	},
];

export const PodcastList = observer(() => {
	const [selectedEpisode, setSelectedEpisode] = useState<PodcastModel>(hardcodedPodcasts[0]);

	return (
		<div className="pad-1rem">
			<div className="pad-bottom-2rem">
				<strong>Podcast-Special</strong>
				<p>Rund um das Pro3-Vertretungsvertragsmodell</p>
			</div>

			<strong>Episoden</strong>
			<div className="grid is-col-1-3">
				{/* Episode List */}
				<div>
					<ul className="podcast-episode-list">
						{hardcodedPodcasts.map((podcast, index) => (
							<li key={podcast.id} className={selectedEpisode.id === podcast.id ? 'is-active' : ''} onClick={() => setSelectedEpisode(podcast)}>
								<small className="podcast-episode">Episode {index + 1}</small>
								<strong className="podcast-title">{podcast.title}</strong>
								<small className="podcast-authors">Von: {selectedEpisode.authors}</small>
							</li>
						))}
					</ul>
				</div>

				{/* Player and Episode Details */}

				<PodcastPlayer key={selectedEpisode.id} audioFilePath={selectedEpisode.audioFilePath} videoFilePath={selectedEpisode.videoFilePath} title={selectedEpisode.title} />
			</div>
		</div>
	);
});
